import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { ServiceDescConfig } from '../../../core/interfaces/service-desc.interface';
import { ServiceCodeEnum } from '../../../core/enums/service.enum';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-service-description',
  templateUrl: './service-description.component.html',
  styleUrls: ['./service-description.component.scss']
})
export class ServiceDescriptionComponent implements OnInit {
  @Input() serviceConfig!: ServiceDescConfig;
  @Output() continue = new EventEmitter<void>();
  ServiceCodeEnum = ServiceCodeEnum;

  activeTab!: string;
  constructor(
    private route: ActivatedRoute
  ) { }

   ngOnInit() {
    this.route.queryParamMap.subscribe(queryParams => {
      const type = queryParams.get('type');
      if (type) {
        this.activeTab = 'Appointment';
      } else {
        this.activeTab = 'Service';
      }

    });
  }

  onContinue() {
    this.continue.emit();
  }
}
